import $api from "../http";
import { IPaymentMethod } from "../models/PaymentMethod";
import { IModelForBuyingSubscription } from "../models/Subscription";
import { IModelForBuyingAddon } from "../models/Addon";

class PaymixServiceClass {
  async getAllPaymentMethods(userId: string) {
    return await $api.get<IPaymentMethod[]>(`api/paymix/payment-method/get-all/${userId}`);
  }

  async attachPaymentMethod(userId: string, cardDetails: string, redirectUrl: string) {
    return await $api.post<{}>(`api/paymix/payment-method/attach`, {
      userId,
      cardDetails,
      redirectUrl,
    });
  }

  async detachPaymentMethod(id: string) {
    return await $api.delete<{}>(`api/paymix/payment-method/detach/${id}`);
  }

  async changeDefaultPaymentMethod(model: { userId: string; referenceId: string }) {
    return await $api.post<{}>(`api/paymix/payment-method/change-default`, { ...model });
  }

  async buySubscription(model: IModelForBuyingSubscription) {
    return $api.post<{ isSuccess: boolean; redirectUrl?: string }>(
      `api/paymix/subscription/buy`,
      model
    );
  }

  async cancelSubscription(userSubscriptionId: string) {
    return $api.post<{}>(`api/paymix/subscription/cancel`, { userSubscriptionId });
  }

  async buyAddon(model: IModelForBuyingAddon) {
    return $api.post<{ isSuccess: boolean; redirectUrl?: string }>(`api/paymix/addon/buy`, model);
  }
}

export const PaymixService = new PaymixServiceClass();
